import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const ChatbotFollowupPage = lazy(() => import('./pages/ChatbotFollowupPage'));

export const ROUTES = [
    {
        path: '/chatbot-followup',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ChatbotFollowupPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
